import { contactEmail, navItems, siteName } from "@/mocks/gossip";

const topicLinks = [
  { label: "课堂八卦", href: "#fresh" },
  { label: "宿舍风云", href: "#fresh" },
  { label: "恋爱甜瓜", href: "#fresh" },
  { label: "社团天地", href: "#fresh" },
  { label: "食堂美食", href: "#fresh" },
  { label: "比赛竞技", href: "#fresh" },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-background-300 bg-gradient-to-b from-background-100 to-background-200/70">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary-500 text-background-50">
                <i className="ri-community-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                {siteName}
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              一个面向校园人群的轻娱乐资讯门户，记录今日瓜速递、校园八卦新鲜事与校内事件追踪，陪你理性吃瓜、围观温暖。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-foreground-500">
              投稿与反馈请发邮件至{" "}
              <a
                href={`mailto:${contactEmail}`}
                className="text-primary-600 underline underline-offset-2 hover:text-primary-700"
              >
                {contactEmail}
              </a>
              。本平台为内容爱好者共建的轻娱乐站点，不代表任何学校官方立场，内容以友善与事实为先。
            </p>
          </div>

          <nav aria-label="页脚导航">
            <h4 className="text-sm font-semibold text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {navItems.map((n) => (
                <li key={n.href}>
                  <a
                    href={n.href}
                    className="text-sm text-foreground-600 transition hover:text-primary-700"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="热门分类">
            <h4 className="text-sm font-semibold text-foreground-950">热门分类</h4>
            <ul className="mt-4 space-y-2.5">
              {topicLinks.map((t) => (
                <li key={t.label}>
                  <a
                    href={t.href}
                    className="text-sm text-foreground-600 transition hover:text-primary-700"
                  >
                    {t.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {year} {siteName} · 校园吃瓜爆料 · 全部内容以友善与事实为先
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#top"
              className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-foreground-600 transition hover:text-primary-700"
            >
              <i className="ri-arrow-up-line"></i> 回到顶部
            </a>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-800">
              <i className="ri-heart-3-line"></i> 理性吃瓜 · 友好围观
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}